<button
  (click)="toggleDropdown()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  [disabled]="disabled"
  type="button"
  class="btn btn-outline-primary btn-sm"
>
  <i class="bi bi-zoom-in"></i>
  {{ zoomLevel }}%
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPositions]="overlayPositions"
  (backdropClick)="toggleDropdown()"
  (detach)="isOpen = false"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <div class="zoom-control-overlay p-3">
    <div class="d-flex align-items-center gap-2">
      <input
        type="range"
        class="form-range"
        [min]="minZoom"
        [max]="maxZoom"
        [value]="zoomLevel"
        (input)="onZoomChange($event)"
      />
      <a class="zoom-value" [title]="tooltipText" (click)="resetZoom()">{{ zoomLevel }}%</a>
    </div>
  </div>
</ng-template>
